document.addEventListener('DOMContentLoaded', () => {
  const HeaderIds = {
    CloseButton: 'close-button',
    MenuButton: 'menu-button',
  };
  const ClassNames = {
    Subscribe: 'subscribe',
  };

  const closeBtn = document.getElementById(HeaderIds.CloseButton);
  const menuBtn = document.getElementById(HeaderIds.MenuButton);
  const nav = document.getElementsByTagName('nav')[0];
  const subscribe = document.getElementsByClassName(ClassNames.Subscribe)[0];
  const emailLabel = subscribe.getElementsByTagName('p')[0];
  const emailInput = subscribe.getElementsByTagName('input')[0];

  closeBtn.addEventListener('click', () => {
    nav.classList.remove('show');
    nav.classList.add('hide');
    document.body.style.overflow = 'unset';
  });

  menuBtn.addEventListener('click', () => {
    nav.classList.remove('hide');
    nav.classList.add('show');
    document.body.style.overflow = 'hidden';
  });

  emailInput.addEventListener('blur', () => {
    if (!emailInput.value) {
      emailLabel.classList.remove('hide');
      emailLabel.classList.add('show');
    }
  });

  emailInput.addEventListener('focus', () => {
    emailLabel.classList.remove('show');
    emailLabel.classList.add('hide');
  });
});
